import { z } from 'zod';
import { IDSchema, IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
/**
 * T-TEAM-001-FOUNDATION — Team entity (data model §21).
 *
 * Org-unit grouping that scopes which Accounts an `opsAdmin` can see. The
 * `teamType` is OPEN-ENDED (region / vertical / industry / pod / etc.) —
 * stored as free-form text, NOT an enum, so the taxonomy can evolve without
 * a schema migration. The application layer offers a recommended-values list
 * for UX only.
 *
 * Q1 (RESOLVED 2026-05-29) — FLAT for V1. No `parentTeamId`; nesting is a
 * non-breaking post-V1 addition if needed.
 *
 * Q4 (RESOLVED 2026-05-29) — Team deletion is a REQUIRED MERGE ACTION. A Team
 * with active `UserTeamMembership` rows or `scopeTeamIds` references cannot be
 * soft-deleted directly; the admin merges Team A into Team B first (see
 * `repositories/team-merge.ts`), which rewrites memberships + scope refs, then
 * the now-empty Team is soft-deleted.
 */
export const TeamSchema = z.object({
    id: IDSchema,
    type: z.literal('team'),
    schemaVersion: SchemaVersionSchema,
    name: z.string().min(1),
    // OPEN-ENDED string (NOT an enum) — recommended values: region | vertical |
    // industry | pod | other. The taxonomy can grow without a migration.
    teamType: z.string().min(1),
    description: z.string().optional(),
    createdAt: IsoTimestampSchema,
    createdBy: z.string(),
    updatedAt: IsoTimestampSchema,
    updatedBy: z.string(),
    deletedAt: IsoTimestampSchema.nullable().optional(),
    version: z.number().int().positive(),
});
/** Recommended (not enforced) team-type values for admin-UI dropdowns. */
export const RECOMMENDED_TEAM_TYPES = [
    'region',
    'vertical',
    'industry',
    'pod',
    'other',
];
//# sourceMappingURL=team.js.map